import React from 'react';
import { Card, Divider, Space, Typography } from 'antd';
import { formatDateTime } from '../../../../utils';

const { Text } = Typography;

interface BillDetailGeneralInfoCardProps {
  counterpartyLabel: string;
  userLabel: string;
  contactName?: string | null;
  contactDocument?: string | null;
  approvedByUserName?: string | null;
  posName?: string | null;
  documentDate?: string | null;
  paymentTerm?: string | null;
}

export const BillDetailGeneralInfoCard: React.FC<BillDetailGeneralInfoCardProps> = ({
  counterpartyLabel,
  userLabel,
  contactName,
  contactDocument,
  approvedByUserName,
  posName,
  documentDate,
  paymentTerm
}) => {
  return (
    <Card title="Información General" className="card-shadow">
      <Space direction="vertical" style={{ width: '100%' }}>
        <div>
          <Text type="secondary">{counterpartyLabel}</Text>
          <div style={{ fontWeight: 'bold' }}>{contactName}</div>
          <div>{contactDocument}</div>
        </div>
        <Divider style={{ margin: '5px 0' }} />
        <div>
          <Text type="secondary">{userLabel}</Text>
          <div>{approvedByUserName}</div>
        </div>
        <Divider style={{ margin: '5px 0' }} />
        <div>
          <Text type="secondary">Punto de Venta:</Text>
          <div>{posName}</div>
        </div>
        <Divider style={{ margin: '5px 0' }} />
        <div>
          <Text type="secondary">Fecha de Emisión:</Text>
          <div>{formatDateTime(documentDate)}</div>
        </div>
        <Divider style={{ margin: '5px 0' }} />
        <div>
          <Text type="secondary">Término de Pago:</Text>
          <div>{paymentTerm === 'CASH' ? 'Contado' : 'Crédito'}</div>
        </div>
      </Space>
    </Card>
  );
};
